import { Routes } from '@/lib/routes/routes';
import { DestinationValue, DestinationValues } from '@/types/cms';
import { Link } from '@/i18n/routing';
import { ReactNode, FC } from 'react';
import ListOfBranchesDestination from './ListOfBranchesDestination';

type Props = {
  destination: DestinationValues;
  destinationValue: DestinationValue;
  children: ReactNode;
};

const ProductDestination: FC<{ destinationValue: DestinationValue; children: ReactNode }> = ({
  children,
  destinationValue,
}) => (
  <Link
    href={Routes.productDetails(
      String(destinationValue.StoreId),
      String(destinationValue.ProductId),
    )}
  >
    <span className="sr-only">View product details</span>

    {children}
  </Link>
);

const StoreDestination: FC<{ destinationValue: DestinationValue; children: ReactNode }> = ({
  children,
  destinationValue,
}) => (
  <Link href={Routes.branchDetails(String(destinationValue?.Branches[0]?.id))}>
    {' '}
    <span className="sr-only">View product details</span>
    {children}
  </Link>
);

const NoDestination: FC<{ children: ReactNode }> = ({ children }) => <>{children}</>;

const RenderDestination: FC<Props> = ({ destination, destinationValue, children }) => {
  switch (destination) {
    case DestinationValues.PRODUCT:
      return (
        <ProductDestination destinationValue={destinationValue}>{children}</ProductDestination>
      );
    case DestinationValues.STORE:
      return <StoreDestination destinationValue={destinationValue}>{children}</StoreDestination>;
    case DestinationValues.LIST_OF_BRANCHES:
      return (
        <ListOfBranchesDestination destinationValue={destinationValue}>
          {children}
        </ListOfBranchesDestination>
      );
    case DestinationValues.NO_DESTINATION:
    default:
      return <NoDestination>{children}</NoDestination>;
  }
};

export default RenderDestination;
